export default __webpack_public_path__ + "static/media/divider-coin-lite.f3615509.svg";